import React from "react";
import { useMessageSource } from "react-message-source";
import { ChangeEventHandler } from "../../../../ui/widgets/types";
import TextInputField from "../formik/text-input";

export default function FirstName({
  forceReRender,
  dataPath = "",
  value,
  onChange,
  shrinkFirstNameLabel,
}: {
  forceReRender?: boolean;
  dataPath?: string;
  value: string;
  onChange?: ChangeEventHandler;
  shrinkFirstNameLabel?: boolean;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <TextInputField
      forceReRender={forceReRender}
      shrink={shrinkFirstNameLabel}
      name={`${dataPath}firstName`}
      label={getMessage("Person.firstName")}
      value={value}
      onChange={onChange}
    />
  );
}
